import { FormItemInputContext as u } from "../components/ReoForm/context/FormItemInputContext.mjs";
import "../components/ReoForm/context/ReoFormCompContext.mjs";
import r from "react";
const n = (s) => {
  const t = r.useContext(u);
  return r.useMemo(() => {
    if (s.status)
      return s.status;
    if (t.status === "error" || t.status === "warning")
      return t.status;
  }, [t.status, s.status]);
};
export {
  n as useCurrentStatus
};
//# sourceMappingURL=useCurrentStatus.mjs.map
